import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IOption, Menu, IPopupProps, IconTypesKeys } from "@evergis/ui";

import { PopupWithCustomBlank } from "../styled";
import { useToggle } from "../../../hooks/useToggle";
import { useLayerSelectOptions } from "../hooks/useLayerSelectOptions";

export interface AddLayerButtonProps {
  toggleMenu: VoidFunction;
  innerRef: (node: null | HTMLElement) => void;
}

interface AddLayerProps {
  Button: FC<AddLayerButtonProps>;
  popupProps?: Partial<IPopupProps>;
}

export const AddLayer: FC<AddLayerProps> = ({ Button, popupProps }) => {
  const [isVisiblePopup, togglePopup] = useToggle(false);
  const { t } = useTranslation("layerList");

  const options = [
    { text: t("layer", { ns: "common" }), heading: true },
    { text: t("catalog"), value: "openFileCatalog", icon: "folder" as IconTypesKeys },
    { text: t("uploadData"), value: "downloadData", icon: "upload" as IconTypesKeys },
    { text: t("createNewLayer"), value: "createNew", icon: "layers" as IconTypesKeys },
    { text: t("addTmsService"), value: "addTmsService", icon: "externalservice" as IconTypesKeys },
    { text: t("eqlQuery"), value: "createEqlQuery", icon: "query" as IconTypesKeys },
    { text: t("group", { ns: "common" }), heading: true },
    { text: t("addGroup"), value: "addGroup", icon: "add_group" as IconTypesKeys },
  ];

  const selectOption = useLayerSelectOptions();

  const onSelect = useCallback(
    (items: IOption[]) => {
      selectOption(items);

      isVisiblePopup && togglePopup();
    },
    [isVisiblePopup, selectOption, togglePopup],
  );

  return (
    <PopupWithCustomBlank
      isVisible={isVisiblePopup}
      onRequestClose={togglePopup}
      anchor={ref => <Button innerRef={ref} toggleMenu={togglePopup} />}
      placement="bottom"
      {...popupProps}
    >
      <Menu options={options} selectOption={onSelect} />
    </PopupWithCustomBlank>
  );
};
